/**
 * dualListBox.buttons.js - Add / Remove buttons for dualListBox.
 * Requires: dualListBox.js, jQuery, Bootstrap (for .btn classes)
 *
 * Adds optional center buttons: Add, Add All, Remove, Remove All.
 * Can render a button strip into a container or bind to existing buttons.
 *
 * Usage after creating chooser:
 *   $.dualListBox.buttons(chooser, { container: '#buttonColumn', labels: { add: 'Add', addAll: 'Add All', ... } });
 * Or pass option: buttons: { container: '#id' } when creating chooser.
 */
(function ($) {
	'use strict';

	var defaultLabels = {
		add: 'Add',
		addAll: 'Add All',
		remove: 'Remove',
		removeAll: 'Remove All'
	};

	function moveSelected(fromList, toList, chooser) {
		var $sel = fromList.getSelection();
		if (!$sel.length) return;
		$sel.appendTo(toList);
		fromList.clearSelection(true);
		toList.trigger('selectionChanged', [toList]);
		fromList.trigger('selectionChanged', [fromList]);
		chooser.trigger('listChanged', [$sel, toList]);
	}

	function moveAll(fromList, toList, chooser) {
		var $all = fromList.getFields();
		if (!$all.length) return;
		$all.appendTo(toList);
		fromList.clearSelection(true);
		toList.trigger('selectionChanged', [toList]);
		fromList.trigger('selectionChanged', [fromList]);
		chooser.trigger('listChanged', [$all, toList]);
	}

	function renderButtons(chooser, options) {
		var opts = $.extend({ container: null, labels: {} }, options);
		var labels = $.extend({}, defaultLabels, opts.labels);
		var $container = $(opts.container);
		if (!$container.length) {
			if (typeof console !== 'undefined' && console.warn) {
				console.warn('dualListBox.buttons: container not found:', opts.container);
			}
			return chooser;
		}

		var src = chooser.getSourceList();
		var dest = chooser.getDestinationList();

		var html =
			'<div class="dlb-buttons">' +
			'<button type="button" class="btn btn-success btn-sm dlb-add" title="' + labels.add + '"><i class="fa fa-angle-right"></i></button>' +
			'<button type="button" class="btn btn-success btn-sm dlb-add-all" title="' + labels.addAll + '"><i class="fa fa-angles-right"></i></button></br></br>' +
			'<button type="button" class="btn btn-warning btn-sm dlb-remove" title="' + labels.remove + '"><i class="fa fa-angle-left"></i></button>' +
			'<button type="button" class="btn btn-warning btn-sm dlb-remove-all" title="' + labels.removeAll + '"><i class="fa fa-angles-left"></i></button>' +
			'</div>';

		$container.html(html);

		$container.find('.dlb-add').on('click', function () {
			moveSelected(src, dest, chooser);
		});
		$container.find('.dlb-add-all').on('click', function () {
			moveAll(src, dest, chooser);
		});
		$container.find('.dlb-remove').on('click', function () {
			moveSelected(dest, src, chooser);
		});
		$container.find('.dlb-remove-all').on('click', function () {
			moveAll(dest, src, chooser);
		});

		return chooser;
	}

	$.dualListBox = $.dualListBox || {};
	$.dualListBox.buttons = function (chooser, options) {
		return renderButtons(chooser, options || {});
	};

}(jQuery));
